(function () {
  function init() {
    var footer = document.querySelector('.footer');
    if (!footer) return;

    var columns = footer.querySelectorAll('.footer__links-column');

    columns.forEach(function (column) {
      var trigger = column.querySelector('.footer__links-trigger');
      var icon = column.querySelector('.footer__links-icon');
      if (!trigger || !icon) return;

      if (trigger.dataset.accordionBound) return;
      trigger.dataset.accordionBound = 'true';

      trigger.addEventListener('click', function () {
        var accordionActive = window.getComputedStyle(icon).display !== 'none';
        if (!accordionActive) return;
        column.classList.toggle('footer__links-column--active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
